import { render, staticRenderFns } from "./SustainabilityPage.vue?vue&type=template&id=33e27536&scoped=true&"
import script from "./SustainabilityPage.vue?vue&type=script&lang=js&"
export * from "./SustainabilityPage.vue?vue&type=script&lang=js&"
import style0 from "./SustainabilityPage.vue?vue&type=style&index=0&id=33e27536&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e27536",
  null
  
)

export default component.exports